<template>
  <div class="container">
    <div class="wrapper">
      <div class="sidebar desktopView">
        <ProfileSidebarComponent></ProfileSidebarComponent>
      </div>
      <div class="main container-fluid">
        <router-view />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProfileSidebarComponent from "../components/ProfileSidebarComponent";

export default {
  metaInfo() {
    return {
      title: "用户中心",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "用户中心包括订阅标签、实时通讯、绑定微信登录、修改个人资料、查看我发布的的话题和回复、查看话题草稿等功能。"
        },
        {
          vmid: "og:type",
          name: "og:type",
          content: "profile"
        },
        {
          vmid: "og:url",
          name: "og:url",
          content: "https://www.99huaren.com/user/settings"
        },
        {
          vmid: "profile:gender",
          name: "profile:gender",
          content: this.user.gender
        },
        {
          vmid: "profile:user_name",
          name: "profile:user_name",
          content: this.user.name
        }
      ],
      link: [
        {
          once: true,
          rel: "canonical",
          href: "https://www.99huaren.com/user/settings"
        }
      ]
    };
  },
  components: { ProfileSidebarComponent },
  computed: {
    ...mapState(["user"])
  }
};
</script>
